// This file centralizes all image imports for easier management

// Import all images
import mainImage from './main.png';
import main1Image from './main1.png';
import main3Image from './main3.png';
import main4Image from './main4.png';
import main5Image from './main5.png';
import main6Image from './main6.png';

// Export images for use in components
export const heroMain = mainImage;
export const exitReadyHero = main1Image;
export const scalePathHero = main3Image;
export const clientsHero = main4Image;
export const caseStudiesHero = main5Image;
export const teamImage = main6Image;

// Export a default object with all images
const images = {
  heroMain: mainImage,
  exitReadyHero: main1Image,
  scalePathHero: main3Image,
  clientsHero: main4Image,
  caseStudiesHero: main5Image,
  teamImage: main6Image
};

export default images;